/**
 * Feature-path context and fetch-planning type definitions.
 *
 * These types describe the legacy path-shaped context cache and the analyzer/fetch hints
 * still used while cached experiment state is converted into Rust `ContextSnapshot`s.
 * Feature support, authoring metadata, and materialization truth live in the Rust-owned
 * context feature registry.
 */
export var ZweigBreadthThrustState;
(function (ZweigBreadthThrustState) {
    ZweigBreadthThrustState["idle"] = "idle";
    ZweigBreadthThrustState["belowLowerThreshold"] = "belowLowerThreshold";
    ZweigBreadthThrustState["setupWindow"] = "setupWindow";
    ZweigBreadthThrustState["thrustEvent"] = "thrustEvent";
    ZweigBreadthThrustState["postEvent"] = "postEvent";
})(ZweigBreadthThrustState || (ZweigBreadthThrustState = {}));
//# sourceMappingURL=FeaturePathTypes.js.map